import * as types from "./actionTypes";


export const fetchFamilyMembersRequest = (customerId) => ({
  type: types.FETCH_FAMILY_MEMBERS_REQUEST,
  payload: { customerId }
});

export const fetchFamilyMembersSuccess = (familyMembers) => ({
  type: types.FETCH_FAMILY_MEMBERS_SUCCESS,
  payload: familyMembers
});

export const fetchFamilyMembersFailure = (error) => ({
  type: types.FETCH_FAMILY_MEMBERS_FAILURE,
  payload: error
});


export const addFamilyMemberRequest = (familyMember) => ({
  type: types.ADD_FAMILY_MEMBER_REQUEST,
  payload: familyMember
});

export const addFamilyMemberSuccess = (familyMember) => ({
  type: types.ADD_FAMILY_MEMBER_SUCCESS,
  payload: familyMember
});

export const addFamilyMemberFailure = (error) => ({
  type: types.ADD_FAMILY_MEMBER_FAILURE,
  payload: error
});

export const updateFamilyMemberRequest = (familyMember) => ({
  type: types.UPDATE_FAMILY_MEMBER_REQUEST,
  payload: familyMember
});

export const updateFamilyMemberSuccess = (familyMember) => ({
  type: types.UPDATE_FAMILY_MEMBER_SUCCESS,
  payload: familyMember
});

export const updateFamilyMemberFailure = (error) => ({
  type: types.UPDATE_FAMILY_MEMBER_FAILURE,
  payload: error
});

export const deleteFamilyMemberRequest = (familyMemberId) => ({
  type: types.DELETE_FAMILY_MEMBER_REQUEST,
  payload: familyMemberId
});

export const deleteFamilyMemberSuccess = (familyMemberId) => ({
  type: types.DELETE_FAMILY_MEMBER_SUCCESS,
  payload: familyMemberId
});

export const deleteFamilyMemberFailure = (error) => ({
  type: types.DELETE_FAMILY_MEMBER_FAILURE,
  payload: error
});


export const fetchFamilyMemberRequest = (id) => ({
  type: types.FETCH_FAMILY_MEMBER_REQUEST,
  payload: id
});

export const fetchFamilyMemberSuccess = (data) => ({
  type: types.FETCH_FAMILY_MEMBER_SUCCESS,
  payload: data
});

export const fetchFamilyMemberFailure = (error) => ({
  type: types.FETCH_FAMILY_MEMBER_FAILURE,
  payload: error
});

export const resetFamilyMember = () => {
  return {
    type: types.RESET_FAMILY_MEMBER
  };
};
